export default "__VITE_ASSET__4633122b__"